import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import DeleteIcon from "@commonComponents/deleteIcon";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { selectAuthTypeList, selectAuthTypeListItems } from "@EUForms/selectors";
import { useSelector } from "react-redux";

const AuthorizationForm=(props)=>{
  const {
    dataSource,
    translate,
    onBlur,
    deleteData,
    onChange,
    onSelect,
    tableName,
    renderAtLast,
    isItemsTab=false,
    markedDeleted, 
    isAuthorizationDisabled
  } = props
  const {id,eoriNo,type}=dataSource
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>onSelect(id,tableName,{[name]:value,id},name),[tableName,id,onSelect])
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  const typeList=useSelector(isItemsTab ? selectAuthTypeListItems : selectAuthTypeList)
  
  return (
    <div  className="formContainer">
        
    <Grid.Row>
      <Grid.Column>
        <DropDown
          id={`authType${id}`}
          label={"TYPE"}
          labelClass="text-none"
          clearable
          name="type"
          data={typeList}
          value={type}
          text={type}
          onChange={onDropDownChange}
          isDisabled={isAuthorizationDisabled}
        />
      </Grid.Column>
      <Grid.Column>
        <InputField
          id={`authIdentification${id}`}
          name="eoriNo"
          type="text"
          label={"IDENTIFICATION"}
          className="field-bg"
          value={eoriNo}
          clearInput={false}
          onChange={onChangeHandler}//updateData(id,{"identification":value})}
          onBlur={onBlurHandler}// saveData({id, identification})}
          isDisabled={isAuthorizationDisabled}
        />
      </Grid.Column>
       {renderAtLast && renderAtLast({dataSource,onDropDownChange,onChangeHandler,onBlurHandler,onSelect,tableName})}
    
    </Grid.Row>
    <div className="actionbtns">
      {markedDeleted?markedDeleted({id, tableName}):
    <DeleteIcon onClick={()=>deleteData(id,tableName)} />}
    </div>
    </div>
  );
}
AuthorizationForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(AuthorizationForm)
